import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatTableModule, MatCheckboxModule, MatSelectModule, MatExpansionModule, MatSliderModule, MatAutocompleteModule, MatDialogModule, MatRadioModule, MatStepperModule, MatButtonModule, MatSidenavModule, MatIconModule, MatPaginatorModule, MatSortModule, MatSnackBarModule, MatCardModule, MatTooltipModule } from '@angular/material';
import { Ng5SliderModule } from 'ng5-slider';
import { NgxSpinnerModule } from 'ngx-spinner';//slider

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DragDropModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatCheckboxModule,
    MatSelectModule,
    MatExpansionModule,
    MatSliderModule,
    MatAutocompleteModule,
    MatDialogModule,
    Ng5SliderModule,
    MatRadioModule,
    MatStepperModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    MatCardModule,
    MatPaginatorModule,
    MatSortModule,
    NgxSpinnerModule,
    MatSelectModule,
    MatTooltipModule
  ],
  exports: [
    CommonModule,
    DragDropModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatCheckboxModule,
    MatSelectModule,
    MatExpansionModule,
    MatSliderModule,
    MatAutocompleteModule,
    MatDialogModule,
    Ng5SliderModule,
    MatRadioModule,
    MatStepperModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    MatCardModule,
    MatPaginatorModule,
    MatSortModule,
    NgxSpinnerModule,
    MatSelectModule,
    MatTooltipModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MaterialModuleModule { }
